<cx-storefront></cx-storefront>

<ng-template cxOutletRef="ErrorPageTemplate">
  <div class="my-5">
    <h3 class="alert alert-danger">No pudimos encontrar la página que estás buscando.</h3>
    <a class="error-btn" routerLink="/" style="color: #212529; font-size: 16px; text-decoration: none;"> Continuar comprando</a>
  </div>
</ng-template>
